// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================
   CustomModal.css 〈完全版〉
   - flatpickr/他UIの z-index と競合しない
   - ヘッダー/フッター sticky、コンテンツだけスクロール
   - モバイル向けレイアウト最適化
   ============================ */

/* ---- 基本トークン ---- */
:root {
  --cm-z-base:        100000;  /* オーバーレイの基準 z-index */
  --cm-overlay-bg:    rgba(22, 22, 22, 0.6);
  --cm-bg:            #ffffff;
  --cm-fg:            #161616;
  --cm-border:        #e0e0e0;
  --cm-shadow:        0 8px 32px rgba(0,0,0,0.25);
  --cm-radius:        8px;

  --cm-header-pad:    0.875rem 1rem;
  --cm-content-pad:   1rem 1.25rem;
  --cm-footer-pad:    0.75rem 1rem;

  --cm-gap:           0.75rem;

  /* サイズプリセット */
  --cm-w-sm:  480px;
  --cm-w-md:  640px;
  --cm-w-lg:  720px;
  --cm-w-xl:  960px;
}

/* ---- Overlay ---- */
.cm-overlay {
  position: fixed;
  inset: 0;
  background: var(--cm-overlay-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--cm-z-base);
  overscroll-behavior: contain;            /* iOS系の背面スクロール抑止に一助 */
  -webkit-overflow-scrolling: auto;
}

/* ---- Container（スタッキング文脈の親） ---- */
.cm-container {
  position: relative;
  background: var(--cm-bg);
  color: var(--cm-fg);
  border-radius: var(--cm-radius);
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: var(--cm-shadow);
  outline: none;                           /* フォーカスは内側で表示 */
  z-index: calc(var(--cm-z-base) + 10);    /* flatpickr より確実に上 */
}

/* 幅サイズ */
.cm-size-sm { max-width: min(var(--cm-w-sm), 92vw); }
.cm-size-md { max-width: min(var(--cm-w-md), 94vw); }
.cm-size-lg { max-width: min(var(--cm-w-lg), 96vw); }
.cm-size-xl { max-width: min(var(--cm-w-xl), 98vw); }

/* ---- Header ---- */
.cm-header {
  position: sticky;
  top: 0;
  z-index: calc(var(--cm-z-base) + 11);
  display: flex;
  align-items: center;
  padding: var(--cm-header-pad);
  border-bottom: 1px solid var(--cm-border);
  background: var(--cm-bg);
}
.cm-title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.2;
  flex: 1 1;
}
.cm-close {
  appearance: none;
  border: none;
  background: transparent;
  font-size: 1.25rem;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  z-index: calc(var(--cm-z-base) + 12); /* ヘッダーより更に上 */
  pointer-events: auto !important;
  display: inline-grid;
  place-items: center;
  line-height: 1;
}
.cm-close:hover { background: rgba(0,0,0,0.06); }
.cm-close:focus-visible {
  outline: 2px solid #0f62fe; /* Carbonのデフォ青に近い */
  outline-offset: 2px;
}

/* ---- Content（ここだけスクロール） ---- */
.cm-content {
  padding: var(--cm-content-pad);
  overflow: auto;
  position: relative;
  z-index: calc(var(--cm-z-base) + 1);
  -webkit-overflow-scrolling: touch;       /* iOS スムーズスクロール */
}

/* ---- Footer ---- */
.cm-footer {
  position: sticky;
  bottom: 0;
  z-index: calc(var(--cm-z-base) + 11);
  padding: var(--cm-footer-pad);
  border-top: 1px solid var(--cm-border);
  background: var(--cm-bg);
  display: flex;
  gap: var(--cm-gap);
  justify-content: flex-end;
}
@media (max-width: 480px) {
  .cm-footer { flex-direction: column-reverse; }
}

/* ---- フォーカス支援（コンテナ内） ---- */
.cm-container :focus-visible {
  outline: 2px solid #0f62fe;
  outline-offset: 2px;
}

/* ---- flatpickr / Carbon DatePicker 対応 ----
   ・flatpickr のポップアップは body 直下に出ることがあり、
     その z-index が高くて×ボタンを覆うことがある。
   ・モーダルのほうを上げつつ、flatpickr は下げる。 */
.flatpickr-calendar {
  z-index: calc(var(--cm-z-base) + 5) !important; /* モーダル < ヘッダー < × の順に下 */
}

/* hidden 時は当たり判定を殺す（見た目だけ隠れてる事故対策） */
.flatpickr-calendar.flatpickr-hidden,
.flatpickr-calendar[aria-hidden="true"] {
  pointer-events: none !important;
}

/* モーダル内に flatpickr が居る場合の保険（選択器強度で勝つ） */
.cm-overlay .flatpickr-calendar {
  z-index: calc(var(--cm-z-base) + 5) !important;
}

/* ---- スクロールバー（任意・見た目調整） ---- */
.cm-content::-webkit-scrollbar {
  width: 10px;
}
.cm-content::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2);
  border-radius: 8px;
}
.cm-content::-webkit-scrollbar-track {
  background: transparent;
}

/* ---- モバイル最適化 ---- */
@media (max-width: 680px) {
  .cm-size-sm,
  .cm-size-md,
  .cm-size-lg,
  .cm-size-xl {
    max-width: 96vw;
  }
  .cm-title { font-size: 1rem; }
  .cm-close { width: 28px; height: 28px; font-size: 1.125rem; }
  .cm-content { padding: 0.875rem 1rem; }
}

/* ---- 画面が極端に低い場合（横向き等） ---- */
@media (max-height: 520px) {
  .cm-container { max-height: 94vh; }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomModal.css"],"names":[],"mappings":"AAAA;;;;;iCAKiC;;AAEjC,qBAAqB;AACrB;EACE,0BAA0B,GAAG,sBAAsB;EACnD,yCAAyC;EACzC,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,+CAA+C;EAC/C,uBAAuB;;EAEvB,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;;EAEhC,2BAA2B;;EAE3B,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B,aAAa,sBAAsB;EAC/D,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa,4BAA4B,gBAAgB;EACzD,oCAAoC,KAAK,qBAAqB;AAChE;;AAEA,SAAS;AACT,cAAc,oCAAoC,EAAE;AACpD,cAAc,oCAAoC,EAAE;AACpD,cAAc,oCAAoC,EAAE;AACpD,cAAc,oCAAoC,EAAE;;AAEpD,qBAAqB;AACrB;EACE,gBAAgB;EAChB,MAAM;EACN,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yCAAyC;EACzC,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oCAAoC,EAAE,cAAc;EACpD,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;AACA,kBAAkB,4BAA4B,EAAE;AAChD;EACE,0BAA0B,EAAE,mBAAmB;EAC/C,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,iCAAiC,QAAQ,kBAAkB;AAC7D;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,6BAA6B;EAC7B,sCAAsC;EACtC,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa,8BAA8B,EAAE;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;kCAGkC;AAClC;EACE,8CAA8C,EAAE,yBAAyB;AAC3E;;AAEA,qCAAqC;AACrC;;EAEE,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC;EACE,8CAA8C;AAChD;;AAEA,gCAAgC;AAChC;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;;;;IAIE,eAAe;EACjB;EACA,YAAY,eAAe,EAAE;EAC7B,YAAY,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;EAC5D,cAAc,sBAAsB,EAAE;AACxC;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB,gBAAgB,EAAE;AACpC","sourcesContent":["/* ============================\n   CustomModal.css 〈完全版〉\n   - flatpickr/他UIの z-index と競合しない\n   - ヘッダー/フッター sticky、コンテンツだけスクロール\n   - モバイル向けレイアウト最適化\n   ============================ */\n\n/* ---- 基本トークン ---- */\n:root {\n  --cm-z-base:        100000;  /* オーバーレイの基準 z-index */\n  --cm-overlay-bg:    rgba(22, 22, 22, 0.6);\n  --cm-bg:            #ffffff;\n  --cm-fg:            #161616;\n  --cm-border:        #e0e0e0;\n  --cm-shadow:        0 8px 32px rgba(0,0,0,0.25);\n  --cm-radius:        8px;\n\n  --cm-header-pad:    0.875rem 1rem;\n  --cm-content-pad:   1rem 1.25rem;\n  --cm-footer-pad:    0.75rem 1rem;\n\n  --cm-gap:           0.75rem;\n\n  /* サイズプリセット */\n  --cm-w-sm:  480px;\n  --cm-w-md:  640px;\n  --cm-w-lg:  720px;\n  --cm-w-xl:  960px;\n}\n\n/* ---- Overlay ---- */\n.cm-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--cm-overlay-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--cm-z-base);\n  overscroll-behavior: contain;            /* iOS系の背面スクロール抑止に一助 */\n  -webkit-overflow-scrolling: auto;\n}\n\n/* ---- Container（スタッキング文脈の親） ---- */\n.cm-container {\n  position: relative;\n  background: var(--cm-bg);\n  color: var(--cm-fg);\n  border-radius: var(--cm-radius);\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--cm-shadow);\n  outline: none;                           /* フォーカスは内側で表示 */\n  z-index: calc(var(--cm-z-base) + 10);    /* flatpickr より確実に上 */\n}\n\n/* 幅サイズ */\n.cm-size-sm { max-width: min(var(--cm-w-sm), 92vw); }\n.cm-size-md { max-width: min(var(--cm-w-md), 94vw); }\n.cm-size-lg { max-width: min(var(--cm-w-lg), 96vw); }\n.cm-size-xl { max-width: min(var(--cm-w-xl), 98vw); }\n\n/* ---- Header ---- */\n.cm-header {\n  position: sticky;\n  top: 0;\n  z-index: calc(var(--cm-z-base) + 11);\n  display: flex;\n  align-items: center;\n  padding: var(--cm-header-pad);\n  border-bottom: 1px solid var(--cm-border);\n  background: var(--cm-bg);\n}\n.cm-title {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  line-height: 1.2;\n  flex: 1;\n}\n.cm-close {\n  appearance: none;\n  border: none;\n  background: transparent;\n  font-size: 1.25rem;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  cursor: pointer;\n  position: relative;\n  z-index: calc(var(--cm-z-base) + 12); /* ヘッダーより更に上 */\n  pointer-events: auto !important;\n  display: inline-grid;\n  place-items: center;\n  line-height: 1;\n}\n.cm-close:hover { background: rgba(0,0,0,0.06); }\n.cm-close:focus-visible {\n  outline: 2px solid #0f62fe; /* Carbonのデフォ青に近い */\n  outline-offset: 2px;\n}\n\n/* ---- Content（ここだけスクロール） ---- */\n.cm-content {\n  padding: var(--cm-content-pad);\n  overflow: auto;\n  position: relative;\n  z-index: calc(var(--cm-z-base) + 1);\n  -webkit-overflow-scrolling: touch;       /* iOS スムーズスクロール */\n}\n\n/* ---- Footer ---- */\n.cm-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: calc(var(--cm-z-base) + 11);\n  padding: var(--cm-footer-pad);\n  border-top: 1px solid var(--cm-border);\n  background: var(--cm-bg);\n  display: flex;\n  gap: var(--cm-gap);\n  justify-content: flex-end;\n}\n@media (max-width: 480px) {\n  .cm-footer { flex-direction: column-reverse; }\n}\n\n/* ---- フォーカス支援（コンテナ内） ---- */\n.cm-container :focus-visible {\n  outline: 2px solid #0f62fe;\n  outline-offset: 2px;\n}\n\n/* ---- flatpickr / Carbon DatePicker 対応 ----\n   ・flatpickr のポップアップは body 直下に出ることがあり、\n     その z-index が高くて×ボタンを覆うことがある。\n   ・モーダルのほうを上げつつ、flatpickr は下げる。 */\n.flatpickr-calendar {\n  z-index: calc(var(--cm-z-base) + 5) !important; /* モーダル < ヘッダー < × の順に下 */\n}\n\n/* hidden 時は当たり判定を殺す（見た目だけ隠れてる事故対策） */\n.flatpickr-calendar.flatpickr-hidden,\n.flatpickr-calendar[aria-hidden=\"true\"] {\n  pointer-events: none !important;\n}\n\n/* モーダル内に flatpickr が居る場合の保険（選択器強度で勝つ） */\n.cm-overlay .flatpickr-calendar {\n  z-index: calc(var(--cm-z-base) + 5) !important;\n}\n\n/* ---- スクロールバー（任意・見た目調整） ---- */\n.cm-content::-webkit-scrollbar {\n  width: 10px;\n}\n.cm-content::-webkit-scrollbar-thumb {\n  background: rgba(0,0,0,0.2);\n  border-radius: 8px;\n}\n.cm-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* ---- モバイル最適化 ---- */\n@media (max-width: 680px) {\n  .cm-size-sm,\n  .cm-size-md,\n  .cm-size-lg,\n  .cm-size-xl {\n    max-width: 96vw;\n  }\n  .cm-title { font-size: 1rem; }\n  .cm-close { width: 28px; height: 28px; font-size: 1.125rem; }\n  .cm-content { padding: 0.875rem 1rem; }\n}\n\n/* ---- 画面が極端に低い場合（横向き等） ---- */\n@media (max-height: 520px) {\n  .cm-container { max-height: 94vh; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
